module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm_title",
    attrs: {
      "id": "pagev"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter_001"
    }
  }, [_c('span', {
    staticClass: "toc_hg"
  }, [_vm._v("Chapter One")])]), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter_001"
    }
  }, [_vm._v("1914 – Starting Out")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter_002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hg"
  }, [_vm._v("Chapter Two")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter_002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1915 – The Deepening Conflict")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hg"
  }, [_vm._v("Chapter Three")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1916 – The Realisation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hg"
  }, [_vm._v("Chapter Four")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1917 – Seeing It Through")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hg"
  }, [_vm._v("Chapter Five")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1918 – The Final Push")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hg"
  }, [_vm._v("Chapter Six")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Cross Nurses From The Channel Islands")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hg"
  }, [_vm._v("Chapter Seven")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("War Memorials")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hg"
  }, [_vm._v("Chapter Eight")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Those Who Died After The Armistice")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_page11"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/02_Abouttheauthor"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0